import {ApplicationConfig, inject, InjectionToken, isDevMode, provideAppInitializer} from '@angular/core';
import {provideErrorTailorConfig} from "@ngneat/error-tailor";
import {HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withFetch, withInterceptorsFromDi} from "@angular/common/http";
import {EndpointPrefixInterceptor} from "./common/interceptors/endpoint-prefix.interceptor";
import {AppToastService} from "./common/services/app-toast.service";
import {ErrorInterceptor} from "./common/interceptors/error.interceptor";
import {ConfirmationService, MessageService} from "primeng/api";
import {NgEventBus} from "ng-event-bus";
import {ToastInterceptor} from "./common/interceptors/toast.interceptor";
import {provideImageKitLoader} from "@angular/common";
import {DialogService} from "primeng/dynamicdialog";
import {UserTimezoneInterceptor} from "./common/interceptors/user-timezone.interceptor";
import {provideNgxWebstorage, withLocalStorage, withNgxWebstorageConfig, withSessionStorage} from "ngx-webstorage";
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import {PusherService} from "./services/pusher.service";
import {providePrimeNG} from "primeng/config";
import {ActivatedRoute, provideRouter, Router} from "@angular/router";
import {routes} from "./app-routing.module";
import {provideServiceWorker} from '@angular/service-worker';
import {CsrfTokenService} from "./common/services/csrf-token.service";
import {lastValueFrom, of, switchMap} from "rxjs";
import {catchError} from "rxjs/operators";
import {initializeApp, provideFirebaseApp} from "@angular/fire/app";
import {getMessaging, provideMessaging} from "@angular/fire/messaging";
import {AuthService} from "./common/services/auth.service";
import Aura from '@primeuix/themes/aura';
import {provideGoogleCharts} from "angular-google-charts";

export const TOAST = new InjectionToken('TOAST');
export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyDyP_HecfZhXsv4z_fRHvWnorAmKOOPWwc",
  authDomain: "prime-asia-tv-317006.firebaseapp.com",
  projectId: "prime-asia-tv-317006",
  storageBucket: "prime-asia-tv-317006.firebasestorage.app",
  messagingSenderId: "910206687623",
  appId: "1:910206687623:web:94843321501ba2f14e5b22",
  measurementId: "G-SW5KCFVQXB",
  vapid: 'BJv61rX0IJwfmOSulcaqUipsZEO65wI5o01As4lRpurOKq18Ae-NUxCRYQCIfmowNw-VsbJNyCVuvAaLVDGxXJk'
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideGoogleCharts(),
    // provideZonelessChangeDetection(),
    provideFirebaseApp(() => initializeApp(FIREBASE_CONFIG)),
    provideMessaging(() => getMessaging()),
    provideAnimationsAsync(),
    provideAppInitializer(() => {
      const pusherService = inject(PusherService);
      const csrfTokenService = inject(CsrfTokenService);
      const router = inject(Router);
      const http = inject(HttpClient);
      const authService = inject(AuthService);
      const activatedRoute = inject(ActivatedRoute);
      const currentUrl = activatedRoute.pathFromRoot;
      var v = lastValueFrom(
        csrfTokenService.getToken()
          .pipe(
            switchMap((token) => {
              return http.post('validate-session', {})
            }),
            catchError((err) => {
              return of(null); // Prevent failure from stopping the app
            })
          )
      ).catch((err) => {
        authService.logout();
        return router.navigate(['/']).then();
      });
      return v;
    }),
    provideRouter(routes),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false
        }
      },

    }),

    provideHttpClient(withFetch(), withInterceptorsFromDi(),),
    provideNgxWebstorage(
      withNgxWebstorageConfig({separator: ':', caseSensitive: true}),
      withLocalStorage(),
      withSessionStorage()
    ),
    NgEventBus,
    DialogService,
    MessageService,
    ConfirmationService,
    provideImageKitLoader('https://ik.imagekit.io/aqcg4zaiu7s/'),
    {provide: HTTP_INTERCEPTORS, useClass: UserTimezoneInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: EndpointPrefixInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ToastInterceptor, multi: true},
    {provide: TOAST, useClass: AppToastService},
    provideErrorTailorConfig({
      errors: {
        useFactory() {
          return {
            required: 'This field is required',
            email: 'Invalid email address',
            confirmedValidator: 'Password dont match',
            passwordsNotMatch: 'Passwords dont match',
            minlength: ({requiredLength, actualLength}) => `Expect ${requiredLength} but got ${actualLength}`,
            invalidAddress: error => `Address not valid`,
          };
        },
        deps: [],
      },
      //controlErrorComponent: CustomControlErrorComponent, // Uncomment to see errors being rendered using a custom component
      //controlErrorComponentAnchorFn: controlErrorComponentAnchorFn // Uncomment to see errors being positioned differently
    }),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
  ]
}

